export default __webpack_public_path__ + "static/media/p9.1c9b148e.jpg";